// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__13XUa","rootSmall":"AddTileButton_rootSmall__1CuEk"};